import {getArray, getBool} from 'Core/helpers/data';
import {get} from 'lodash';

/**
 * Unique Redux store key associated with this reducer
 * IMPORTANT: All reducers must export this value!
 * @type {string}
 */
export const reducerStoreKey = 'customerGroupImport';

// Define reducer types handled by this reducer
export const REDUCER_TYPES = {
	RESET: '@customerGroupImport/reset',
	SET_IN_PROGRESS_CHANGE_REQUESTS: '@customerGroupImport/setInProgressChangeRequests',
};

// Define action creators for all reducer types
export const actionCreators = {
	reset: () => ({type: REDUCER_TYPES.RESET}),
	/**
	 * Set the list of in progress requests for changing the customers in a customer group
	 * @param {CustomerGroupChangeRequestDataObject[]} requests - List of in progress change requests.
	 * @return {{type: string, requests: CustomerGroupChangeRequestDataObject[]}}
	 */
	setInProgressChangeRequests: requests => ({type: REDUCER_TYPES.SET_IN_PROGRESS_CHANGE_REQUESTS, requests}),
};

/**
 * Initial reducer state
 * IMPORTANT: All reducers must export an initial state object!
 * @type {Object<string, any>}
 */
export const initialState = {
	/**
	 * List of in progress requests for changing the customers in a customer group
	 * @note Where null means that the list has not been loaded yet and undefined means that there was an error while
	 * trying to get the list.
	 * @type {?CustomerGroupChangeRequestDataObject[]|undefined}
	 */
	inProgressChangeRequests: null,
	
	/**
	 * Flag that specifies if importing customers into customer groups is in progress
	 * @description Import is considered to be in progress if the list of in progress change requests is not empty.
	 * @readonly There is no action creator for setting this because it will be set when setting 
	 * 'inProgressChangeRequests'.
	 * @type {boolean}
	 */
	inProgress: false,
};

// Reducer function
const reducer = (state = {...initialState}, action) => {
	switch (action.type) {
		case REDUCER_TYPES.RESET: return { ...initialState };
		
		case REDUCER_TYPES.SET_IN_PROGRESS_CHANGE_REQUESTS:
			return {
				...initialState, 
				inProgressChangeRequests: action.requests,
				inProgress: (getArray(action, 'requests').length > 0),
			};

		default: return state;
	}
};

// Selectors
export const selectors = {
	getInProgress: state => getBool(state, [reducerStoreKey, 'inProgress']),
	getInProgressChangeRequests: state => get(state, [reducerStoreKey, 'inProgressChangeRequests']),
};

export default reducer;